"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ForgotPassword = exports.Logout = exports.Footer = exports.ExpiredDescription = exports.DefaultDescription = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactI18next = require("react-i18next");

var _formik = require("formik");

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _Input = _interopRequireWildcard(require("../Input"));

var _Button = _interopRequireDefault(require("../Button"));

var _CircularLoader = _interopRequireDefault(require("../CircularLoader"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var LoginModal = function LoginModal(_ref) {
  var isOpen = _ref.isOpen,
      footer = _ref.footer,
      onLogin = _ref.onLogin,
      isLoading = _ref.isLoading,
      description = _ref.description,
      _ref$initialValues = _ref.initialValues,
      initialValues = _ref$initialValues === void 0 ? {} : _ref$initialValues,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["isOpen", "footer", "onLogin", "isLoading", "description", "initialValues"]);

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    open: isOpen,
    fullScreen: true
  }, /*#__PURE__*/_react["default"].createElement(_formik.Formik, (0, _extends2["default"])({}, rest, {
    enableReinitialize: true,
    initialValues: _objectSpread({
      email: '',
      password: ''
    }, initialValues),
    onSubmit: onLogin
  }), function (props) {
    var disabled = isLoading || !props.isValid;
    var initialEmail = props.initialValues.email;
    return /*#__PURE__*/_react["default"].createElement(_formik.Form, {
      className: "px-12 w-full bg-center bg-cover bg-primary h-screen flex",
      style: {
        backgroundImage: "url(".concat(t('onboarding.backgroundImage'), ")")
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "m-auto"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      className: "w-48 mx-auto",
      src: t('onboard-logo'),
      alt: t('onboard-logo')
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "py-3 text-lg text-center"
    }, description), /*#__PURE__*/_react["default"].createElement(_Input["default"], {
      size: "lg",
      name: "email",
      placeholder: "Username",
      autoFocus: !initialEmail,
      className: "w-full mb-2 !text-white placeholder-white",
      style: {
        backgroundColor: 'rgba(255, 255, 255, 0.25)'
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "inline-block w-full"
    }, /*#__PURE__*/_react["default"].createElement(_Input.PasswordInput, {
      size: "lg",
      visibleToggle: true,
      name: "password",
      type: "password",
      placeholder: "Password",
      autoFocus: !!initialEmail,
      className: "mb-2 !text-white placeholder-white",
      style: {
        backgroundColor: 'rgba(255, 255, 255, 0.25)'
      }
    })), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      className: (0, _classnames["default"])('w-full flex items-center justify-center', {
        '!dark:bg-dark': disabled,
        '!bg-white !text-primary': !disabled
      }),
      disabled: disabled
    }, isLoading ? /*#__PURE__*/_react["default"].createElement(_CircularLoader["default"], {
      size: 24,
      color: "inherit"
    }) : t('login.submit')), footer));
  }));
};

var DefaultDescription = function DefaultDescription() {
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation2.t;

  return /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-white text-sm font-semibold"
  }, t('login.modal.description'));
};

exports.DefaultDescription = DefaultDescription;

var ExpiredDescription = function ExpiredDescription() {
  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation3.t;

  return /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-white text-sm font-semibold"
  }, t('login.modal.description.expired'));
};

exports.ExpiredDescription = ExpiredDescription;

var Footer = function Footer(_ref2) {
  var logout = _ref2.logout,
      forgotPassword = _ref2.forgotPassword;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full text-sm mt-4"
  }, forgotPassword);
};

exports.Footer = Footer;

var Logout = function Logout(_ref3) {
  var onClick = _ref3.onClick;

  var _useTranslation4 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation4.t;

  return /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: onClick,
    className: "block m-auto px-2 text-white font-semibold opacity-50 hover:opacity-75"
  }, t('menu.logout'));
};

exports.Logout = Logout;

var ForgotPassword = function ForgotPassword(_ref4) {
  var onClick = _ref4.onClick;

  var _useTranslation5 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation5.t;

  return /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: onClick,
    className: "block m-auto px-2 text-white text-xs font-semibold hover:opacity-75"
  }, t('login.modal.forgotPassword'));
};

exports.ForgotPassword = ForgotPassword;
var _default = LoginModal;
exports["default"] = _default;
//# sourceMappingURL=LoginModal.js.map